<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-selected`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 20a1 1 0 011 1v21a2 2 0 01-2 2H21a1 1 0 01-1-1v-2a1 1 0 011-1h19V21a1 1 0 011-1h2zM35 4a2 2 0 012 2v29a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h29zm-2 4H8v25h25V8zm-5.736 6.707l1.414 1.414a1 1 0 010 1.415l-9.9 9.899a1 1 0 01-1.414 0l-5.657-5.657a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0l3.535 3.535 7.778-7.778a1 1 0 011.415 0z"/></svg>
</template>
<script>

export default {
  name: 'IconSelected',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
